import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { SearchGroupItem } from '@interfaces/common.model';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-field',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatInputModule, FormsModule],
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent {
  @Input() searchValues!: SearchGroupItem;
  @Input() placeholder: string = 'Search by id';

  @Output() search = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<void>();
  searchvalue: string = '';
  private searchSubject = new Subject<string>();
  private debounceDelay = 100; // milliseconds

  constructor() {
    this.searchSubject
      .subscribe((value: string) => {
        this.search.emit(value);
      });
  }

  onKeyup(event: KeyboardEvent): void {
    this.searchvalue = (event.target as HTMLInputElement).value;
    this.searchSubject.next(this.searchvalue);
  }

  clear(): void {
    this.searchvalue = '';
    this.search.emit(this.searchvalue);
  }
}
